
import PropTypes from 'prop-types'
import { createOnFilter } from 'filter'

import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import MuiFormSelect from 'frame/components/mui-form-select'

const FilterAttributes = ({ filters, filtered, onFilter }) => {
  const onSelect = createOnFilter(onFilter)
  const hasList = (list) => list.length > 0
  const { fleets, costCentres, locations, fleetControllers, statuses } = filters

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          paddingY: 1,
          paddingX: 0,
          cursor: 'pointer',
        }}>
        <Typography variant="h5">Filters</Typography>
      </Box>
      <Divider />
      <Stack gap={2} py={2}>
        {hasList(fleets) && (
          <MuiFormSelect
            id="fleet"
            label="Fleet"
            options={fleets}
            value={filtered.fleet}
            onChange={onSelect('fleet')} />
        )}
        {hasList(costCentres) && (
          <MuiFormSelect
            id="costCentre"
            label="Cost Centre"
            options={costCentres}
            value={filtered.costCentre}
            onChange={onSelect('costCentre')} />
        )}
        {hasList(locations) && (
          <MuiFormSelect
            id="location"
            label="Location"
            options={locations}
            value={filtered.location}
            onChange={onSelect('location')} />
        )}
        {hasList(fleetControllers) && (
          <MuiFormSelect
            id="controller"
            label="Fleet Controller"
            options={fleetControllers}
            value={filtered.controller}
            onChange={onSelect('controller')} />
        )}
        {hasList(statuses) && (
          <MuiFormSelect
            id="status"
            label="Status"
            options={statuses}
            value={filtered.status}
            onChange={onSelect('status')} />
        )}
      </Stack>
    </Box>
  )
}

FilterAttributes.propTypes = {
  filters: PropTypes.object.isRequired,
  filtered: PropTypes.object.isRequired,
  onFilter: PropTypes.func.isRequired,
}

export default FilterAttributes
